
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/site/tools",
      function () {
        return require("private-next-pages/site/tools/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/site/tools"])
      });
    }
  